import React, { useContext } from 'react';
import { IGameAssignmentContext, GameAssignmentContext } from '../../../../gameAssignmentState/gameAssignmentContext';
import SearchField from 'components/SearchField/SearchField';
import classNames from 'classnames';
import style from './SearchFields.module.scss';

const SearchFields: React.FC = () => {
	const {
		changeSearchStringForAllCustomers,
		changeSearchStringForRestaurants,
		changeSearchStringForGames,
		searchStringForAllCustomers,
		searchStringForRestaurants,
		searchStringForGames,
		activeItemToDisplay,
	} = useContext<IGameAssignmentContext>(GameAssignmentContext);

	const customerSearchFieldWrapperClasses = classNames(style.searchFieldWrapper, {
		[style.hide]: activeItemToDisplay !== 'customers',
	});
	const restaurantSearchFieldWrapperClasses = classNames(style.searchFieldWrapper, {
		[style.hide]: activeItemToDisplay !== 'restaurants',
	});
	const firmwareSearchFieldWrapperClasses = classNames(style.searchFieldWrapper, {
		[style.hide]: activeItemToDisplay !== 'games',
	});

	return (
		<div className={style.container}>
			<div className={customerSearchFieldWrapperClasses}>
				<SearchField
					onChangeSelectSearchString={changeSearchStringForAllCustomers}
					searchString={searchStringForAllCustomers}
				/>
			</div>
			<div className={restaurantSearchFieldWrapperClasses}>
				<SearchField
					onChangeSelectSearchString={changeSearchStringForRestaurants}
					searchString={searchStringForRestaurants}
				/>
			</div>
			<div className={firmwareSearchFieldWrapperClasses}>
				<SearchField
					onChangeSelectSearchString={changeSearchStringForGames}
					searchString={searchStringForGames}
				/>
			</div>
		</div>
	);
};

export default SearchFields;
